/**
 * Kosár ikon vizuális visszajelzések (AJAX kosárba rakáshoz).
 *
 * 1) A fejléc kosár ikon (.cart-drawer-button.cart-icon) hátterét sárgára/fehérre
 *    állítja a "btn--yellow" class ki/be kapcsolásával, valahányszor a kosár
 *    tartalma AJAX-on keresztül változik (kosárba rakás, mennyiség módosítás,
 *    kupon hozzáadás/eltávolítás, stb.) - anélkül, hogy oldalfrissítés történne.
 *    Az oldal betöltésekor a Liquid már beállítja a helyes állapotot, ezért ez a
 *    szkript csak akkor módosít bármit, ha a tényleges és a megjelenített állapot
 *    eltér egymástól.
 *
 * 2) "Repülő" ikon animáció: a Kosárba gomb megnyomása után egy, a gombon lévő
 *    ikonnal megegyező kis ikon smooth animációval felrepül a fejléc kosár
 *    ikonjáig, jelezve a sikeres kosárba rakást.
 */
(function () {
  'use strict';

  var HEADER_ICON_SELECTOR = '.cart-drawer-button.cart-icon';
  var ADD_TO_CART_FORM_SELECTOR = '[data-type="add-to-cart-form"]';
  var ACTIVE_CLASS = 'btn--yellow';
  var FLIGHT_MAX_AGE_MS = 8000;

  var FALLBACK_ICON_MARKUP =
    '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M16.3804 16.25H3.61947C3.46585 16.25 3.31752 16.1939 3.20241 16.0922C3.0873 15.9904 3.01334 15.8501 2.99447 15.6977L1.88119 6.32267C1.87089 6.2347 1.87941 6.14556 1.90617 6.06113C1.93294 5.9767 1.97734 5.89893 2.03644 5.83296C2.09553 5.767 2.16797 5.71434 2.24896 5.67849C2.32995 5.64264 2.41763 5.62441 2.50619 5.62501H17.4937C17.5823 5.62441 17.6699 5.64264 17.7509 5.67849C17.8319 5.71434 17.9044 5.767 17.9634 5.83296C18.0225 5.89893 18.0669 5.9767 18.0937 6.06113C18.1205 6.14556 18.129 6.2347 18.1187 6.32267L17.0054 15.6977C16.9865 15.8501 16.9126 15.9904 16.7975 16.0922C16.6824 16.1939 16.534 16.25 16.3804 16.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function getHeaderCartIcon() {
    return document.querySelector(HEADER_ICON_SELECTOR);
  }

  /* ---------------------------------------------------------------------
   * 1) Fejléc kosár ikon szín szinkronizálása AJAX kosár eseményekre
   * ------------------------------------------------------------------- */

  function syncHeaderCartIcon(cart) {
    if (!cart || cart.errors || typeof cart.item_count === 'undefined') return;

    var icon = getHeaderCartIcon();
    if (!icon) return;

    var shouldBeActive = cart.item_count > 0;
    var isActive = icon.classList.contains(ACTIVE_CLASS);

    // Ha az ikon már a helyes színben van (a Liquid által betöltéskor beállított
    // állapot még mindig helytálló), nincs teendő - csak eltérés esetén módosítunk.
    if (shouldBeActive !== isActive) {
      icon.classList.toggle(ACTIVE_CLASS, shouldBeActive);
    }
  }

  function initHeaderCartIconSync() {
    if (typeof window.FoxTheme === 'undefined' || !window.FoxTheme.pubsub) return;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      syncHeaderCartIcon(event && event.cart);
    });
  }

  /* ---------------------------------------------------------------------
   * 2) Repülő ikon animáció a Kosárba gombtól a fejléc kosár ikonig
   * ------------------------------------------------------------------- */

  var pendingFlights = [];

  function pruneExpiredFlights() {
    var now = Date.now();
    pendingFlights = pendingFlights.filter(function (flight) {
      return now - flight.time < FLIGHT_MAX_AGE_MS;
    });
  }

  function captureFlightOrigin(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(ADD_TO_CART_FORM_SELECTOR)) return;

    var submitter = event.submitter && event.submitter.matches('[type="submit"]') ? event.submitter : null;
    var button = submitter || form.querySelector('[type="submit"]');
    if (!button) return;

    var rect = button.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var iconEl = button.querySelector('svg');

    pruneExpiredFlights();
    pendingFlights.push({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      iconMarkup: iconEl ? iconEl.outerHTML : FALLBACK_ICON_MARKUP,
      time: Date.now(),
    });
  }

  function consumeFlightOrigin() {
    pruneExpiredFlights();
    return pendingFlights.shift();
  }

  function bumpHeaderCartIcon(icon) {
    icon.classList.remove('cart-icon--bump');
    // Reflow, hogy ismételt egymás utáni kosárba rakásnál is újrainduljon az animáció.
    void icon.offsetWidth;
    icon.classList.add('cart-icon--bump');
    icon.addEventListener(
      'animationend',
      function () {
        icon.classList.remove('cart-icon--bump');
      },
      { once: true }
    );
  }

  function flyToCart(origin) {
    var target = getHeaderCartIcon();
    if (!target) return;

    var targetRect = target.getBoundingClientRect();
    if (!targetRect.width || !targetRect.height) return;

    var destX = targetRect.left + targetRect.width / 2;
    var destY = targetRect.top + targetRect.height / 2;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || typeof origin.x !== 'number' || typeof Element.prototype.animate !== 'function') {
      bumpHeaderCartIcon(target);
      return;
    }

    var flyer = document.createElement('div');
    flyer.className = 'cart-fly-icon';
    flyer.setAttribute('aria-hidden', 'true');
    flyer.innerHTML = origin.iconMarkup || FALLBACK_ICON_MARKUP;
    flyer.style.left = origin.x + 'px';
    flyer.style.top = origin.y + 'px';
    document.body.appendChild(flyer);

    var deltaX = destX - origin.x;
    var deltaY = destY - origin.y;
    // Kifejezettebb ív a repülési pályában, hogy jól látható legyen a mozgás.
    var arcX = deltaX * 0.5;
    var arcY = Math.min(deltaY * 0.4, -70);

    var animation;
    try {
      animation = flyer.animate(
        [
          {
            transform: 'translate(-50%, -50%) translate(0px, 0px) rotate(0deg) scale(0.9)',
            opacity: 1,
            offset: 0,
          },
          {
            // Rövid "pop" indításkor, hogy azonnal magára vonja a figyelmet.
            transform:
              'translate(-50%, -50%) translate(' +
              arcX * 0.12 +
              'px, ' +
              arcY * 0.2 +
              'px) rotate(-10deg) scale(1.35)',
            opacity: 1,
            offset: 0.16,
          },
          {
            transform:
              'translate(-50%, -50%) translate(' + arcX + 'px, ' + arcY + 'px) rotate(8deg) scale(1)',
            opacity: 1,
            offset: 0.55,
          },
          {
            transform:
              'translate(-50%, -50%) translate(' + deltaX + 'px, ' + deltaY + 'px) rotate(0deg) scale(0.3)',
            opacity: 0,
            offset: 1,
          },
        ],
        { duration: 800, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'forwards' }
      );
    } catch (error) {
      flyer.remove();
      bumpHeaderCartIcon(target);
      return;
    }

    var cleanup = function () {
      flyer.remove();
    };

    animation.addEventListener('finish', function () {
      cleanup();
      bumpHeaderCartIcon(target);
    });
    animation.addEventListener('cancel', cleanup);
  }

  function initFlyToCartAnimation() {
    document.addEventListener('submit', captureFlightOrigin, true);

    document.addEventListener('product-ajax:added', function () {
      var origin = consumeFlightOrigin();
      if (!origin) return;
      flyToCart(origin);
    });
  }

  ready(function () {
    initHeaderCartIconSync();
    initFlyToCartAnimation();
  });
})();
